document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-legswell-product]').forEach(function (root) {
    var mainImage = root.querySelector('[data-legswell-product-image-wrap] img');
    var colorName = root.querySelector('[data-legswell-product-color-name]');
    var swatches = root.querySelectorAll('[data-legswell-product-swatch]');

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) {
          s.classList.remove('cls-legswell-product__swatch--active');
        });
        swatch.classList.add('cls-legswell-product__swatch--active');

        if (mainImage && swatch.dataset.image) {
          // The gallery <img> renders with a srcset (from the responsive
          // `widths` list), which browsers prioritize over `src`. Without
          // clearing it, setting `.src` here would have no visible effect.
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = swatch.dataset.image;
        }
        if (colorName && swatch.dataset.colorName) {
          colorName.textContent = swatch.dataset.colorName;
        }
      });
    });
  });
});
